
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ModalWarning from 'Common/Components/ModalWarning';
import { SearchIcon } from './styled';
import { selectAgentExecutionSelected } from 'store/Agents/selectors';
import { setAgentExecutorSeleted } from 'store/Agents/actions';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';
import { isEmpty } from 'lodash';

const Search = () => {
  const dispatch = useDispatch();
  const agentsExecutionsSelected = useSelector(selectAgentExecutionSelected);
  const [showWarning, setShowWarning] = useState(false);
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'assets' });
  const disabled = isEmpty(agentsExecutionsSelected) || agentsExecutionsSelected.length !== 1;

  const handleClick = () => {
    dispatch(setAgentExecutorSeleted(agentsExecutionsSelected[0]));
    dispatch(openModal(MODAL_AGENT_EXECUTOR_DETAIL));
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <SearchIcon title="Detail" onClick={ handleClick } disabled={ disabled } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Delete" description={ message } /> }
    </>
  );
};

export default Search;
